import React from 'react';
import ManageExportColumnSpecComponentVM from './ManageExportColumnSpecComponentVM';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { EnumHelper, ModalUtils, Validation } from '@singularsystems/neo-core';
import { ColumnSpecDataTypeEnum } from '../../ColumnConfigurations/Models/Enums/ColumnSpecDataTypeEnum';

interface IManageColumnSpecComponentProps {
    viewModel: ManageExportColumnSpecComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageColumnSpecComponent extends React.Component<IManageColumnSpecComponentProps> {
    public render() {
        const viewModel = this.props.viewModel;

        return (
            <>
                {<Neo.Card title={viewModel.managedExportColumnSpec.staticExportColumnSpecId === 0 ? TextConstants.Titles.AddColumn : TextConstants.Titles.EditColumn}>
                    <>
                        <Neo.Form model={viewModel.managedExportColumnSpec}
                            validationDisplayMode={Validation.DisplayMode.AfterBlur}
                            onSubmit={() => this.props.onSave()}
                            onInvalid={this.onFormInvalid}>
                            <Neo.GridLayout lg={2}>
                                <Neo.FormGroup bindContext={viewModel.managedExportColumnSpec.meta.fileSpecPropertiesConcatenated} label={TextConstants.Labels.FileType}>
                                    <Neo.AutoCompleteDropDown
                                        itemSource={viewModel.staticExportFileSpecApiClient.getExportFileSpecDropdownList}
                                        bind={viewModel.managedExportColumnSpec.meta.staticExportFileSpecId}
                                        bindDisplay={viewModel.managedExportColumnSpec.meta.fileSpecPropertiesConcatenated}
                                        displayMember={"fileSpecPropertiesConcatenated"}
                                        items={viewModel.staticExportFileSpecApiClient.getExportFileSpecDropdownList(" ").then((arr) => arr.data.slice(0,10)
                                        .sort((x,y)=> x.fileSpecPropertiesConcatenated!.localeCompare(y.fileSpecPropertiesConcatenated!)))}
                                    />
                                </Neo.FormGroup>
                            </Neo.GridLayout>
                            <div className="row">
                                <div className="col-md-2">
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.ColumnNumber}
                                        bind={viewModel.managedExportColumnSpec.meta.columnNumber}/>
                                </div>
                                <div className="col-md-4">
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.FileFieldName}
                                        bind={viewModel.managedExportColumnSpec.meta.fieldName} />
                                </div>
                            </div>
                            <Neo.GridLayout lg={2}>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.Description}
                                    bind={viewModel.managedExportColumnSpec.meta.description}
                                    input={{ rows: 2 }} />
                                <Neo.GridLayout md={3}>
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.DataType}
                                        bind={viewModel.managedExportColumnSpec.meta.dataType}
                                        select={{ items: EnumHelper.asList(ColumnSpecDataTypeEnum), valueMember: "name", displayMember: "name" }}
                                        onChange={() => viewModel.setDateReadOnlyInd()} />
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.DateFormat}
                                        bind={viewModel.managedExportColumnSpec.meta.displayFormat}
                                        isReadOnly={viewModel.isReadOnly} />
                                </Neo.GridLayout>
                            </Neo.GridLayout>
                            <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                        </Neo.Form>
                    </>
                </Neo.Card>
                }
            </>
        );
    }

    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage(TextConstants.Buttons.Save, TextConstants.Validation.InvalidColumn);
        }
    }
}

